import Vue from 'vue'
import NProgress from 'nprogress'
import Router from 'vue-router'
import bar from './routers/bar'
import system from './routers/system'
import hotelCheck from './routers/hotelCheck'
/*const login = () =>
    import('./views/frame/login');*/
/*const index = () =>
    import('./views/frame/index');
const personal = () =>
    import('./views/frame/personal');
const write = () =>
    import('./views/frame/write');
const writeAndUploadImg = () =>
    import('./views/frame/writeAndUploadImg');*/
Vue.use(Router);
const router = new Router({
    routes: [
        {
            path: '/',
            name: 'login',
            component: ()=> import('./views/frame/login')
        },
        {
            path: '/login',
            name: 'login',
            component: ()=> import('./views/frame/login')
        },
        {
            path: '/write',
            name: 'write',
            component: () => import('./views/frame/write')
        },
        {
            path: '/writeAndUploadImg',
            name: 'writeAndUploadImg',
            component: () => import('./views/frame/writeAndUploadImg')
        },
        {
            path: '/index',
            name: 'index',
            component: () => import('./views/frame/index'),
            children: [
                {
                    path: '/personal',
                    name: 'personal',
                    component: () => import('./views/frame/personal')
                },
                ...bar,
                ...system,
                ...hotelCheck,
            ]
        },
    ]
});
router.beforeEach((to, from , next) => {
    // 每次切换页面时，调用进度条
    NProgress.start();

    // 这个一定要加，没有next()页面不会跳转的。这部分还不清楚的去翻一下官网就明白了
    next();
});
router.afterEach(() => {
    // 在即将进入新的页面组件前，关闭掉进度条
    NProgress.done()
});
export default router;